<template>
  <ImageTheme :theme="configuration">
    <ImageAtom
      v-if="imageAtom"
      v-bind="imageAtom"
    />
  </ImageTheme>
</template>

<script lang="ts" setup>
import ImageAtom from '~/components/Atoms/ImageAtom/ImageAtom.vue';
import ImageTheme from '~/components/Molecules/Themes/ImageTheme.vue';
import type { SectionBuilderImage } from '~/sanity/types';
defineProps<SectionBuilderImage>();
</script>

<style></style>
